var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`app is-${_vm.deviceType}`},[_c('navigation'),_c('div',{staticClass:"router-wrapper"},[_c('router-view',{staticClass:"router"})],1),_c('intro-modal',{attrs:{"modal-key":"intro"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }